import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import React from "react"
import { css } from "styled-components"
import Grid from "../../../components/shared/grid"
import { Block, Spacer } from "../../atoms/layout-primitives"
import Text from "../../atoms/text"
import { T } from "../../styles/typography"

const overlay = css`
  background-color: var(--tricorn-black);
  mix-blend-mode: multiply;
  opacity: 0.75;
`

export default function ServiceNowClientPromo(props) {
  const query = useStaticQuery(graphql`
    query {
      background: file(
        relativePath: {
          eq: "4_COMPANY/Security/quote background - source.jpeg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      serviceNowLogo: file(
        relativePath: { eq: "4_COMPANY/Security/service now.svg" }
      ) {
        publicURL
      }
    }
  `)

  return (
    <>
      <BackgroundImage fluid={query.background.childImageSharp.fluid}>
        <Grid overlayStyle={overlay}>
          <Spacer height={{ sm: "48px", md: "48px", lg: "112px" }} />
          {/* service now logo not used yet
              <VariantContainer
                src={query.serviceNowLogo.publicURL}
                alt="service now logo"
                variants={[
                  css`
                    justify-self: center;
                    max-width: 180px;
                    grid-column: 4 / 10;
                  `,
                  css`
                    grid-column: 5 / 9;
                  `,
                  css`
                    max-width: 240px;
                    grid-column: 6 / 8;
                  `,
                ]}
                as="img"
              ></VariantContainer>
              */}
          <Block
            variants={[
              css`
                grid-column: 1 / -1;
                text-align: center;
              `,
              css`
                grid-column: 2 / 12;
              `,
              css`
                grid-column: 3 / 11;
              `,
            ]}
          >
            <Text
              variants={[
                css`
                  ${T.sm.body`400`}
                  color: #FFFFFF;
                  margin-top: 8px;
                `,
                css`
                  margin-top: 16px;
                `,
                css`
                  ${T.body.feature`400`}
                `,
              ]}
            >
              "As Mappedin continues to service large organizations, it's
              important that we ensure our policies and procedures towards data
              security are thoughtful and transparent. With this, we've
              increased our documentation and communication of these policies
              and procedures to give our clients and partners the confidence
              needed to continue to grow with Mappedin."
            </Text>
            <Text
              variants={[
                css`
                  ${T.lg.subheading`500`}
                  color: #FFFFFF;
                  margin-top: 24px;
                  text-transform: uppercase;
                `,
                css``,
                css`
                  ${T.lg.h6`500`}
                  margin-top: 32px;
                `,
              ]}
            >
              Hongwei Liu, CEO of Mappedin
            </Text>
          </Block>
          <Spacer height={{ sm: "48px", md: "48px", lg: "96px" }} />
        </Grid>
      </BackgroundImage>
    </>
  )
}
